export const SEND_MONTHLY_FORM = 'send-monthly-form';
const sendMonthlyForm = ({ data, monthlyPhoneNumber }) => (
  {
    type: SEND_MONTHLY_FORM,
    payload: {
      data,
      monthlyPhoneNumber,
    },
  }
);
export default sendMonthlyForm;
